import { stringify } from 'hub-http/helpers/params';
import { isEmpty } from '../utils/object';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { View } from 'foundations-components/transitional/components/View';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SimpleHubPickerRow = ({
  account,
  redirectTo,
  query
}) => {
  const {
    accountName,
    domain,
    id
  } = account;
  const getRedirectUrl = () => {
    let redirectUrl = redirectTo(id);
    if (!isEmpty(query)) {
      redirectUrl += `${redirectUrl.indexOf('?') === -1 ? '?' : '&'}${stringify(query)}`;
    }
    return redirectUrl;
  };
  const handleRowClick = e => {
    if (e.metaKey) {
      window.open(getRedirectUrl());
    } else {
      window.location.href = getRedirectUrl();
    }
  };
  return /*#__PURE__*/_jsxs(View, {
    as: "tr",
    cursor: "pointer",
    onClick: handleRowClick,
    children: [/*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx("a", {
        href: getRedirectUrl(),
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: accountName
        })
      })
    }), /*#__PURE__*/_jsxs("td", {
      children: [/*#__PURE__*/_jsx(TruncateString, {
        children: domain
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: id
      })]
    })]
  }, accountName);
};
export default SimpleHubPickerRow;